export enum pListType {
    "list_big",
    "list_more",
    "boxed"
}
export interface LayoutState {
    propertyListType: pListType,
    allShow: boolean
}
